import {XauditModel} from '../xaudit.model';
import {InsuranceDataModel} from '../insurance/insurance-data.model';
import {ContactDataModel} from '../person/contact-data.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';

export class PatientInsuranceDataModel extends XauditModel {
  PatientInsuranceID: string;
  PatientId: string;
  InsuranceID: string;
  EmployerNO: string;
  GroupNO: string;
  InsuranceOrder: number;
  CoverageStart: Date;
  CoverageEnd: Date;
  PatientInsuranceNO: string;
  // TODO: Spelling
  SubsciberContactId: string;
  enumInsuranceRelationId: string;
  // TODO: Spelling
  SubsciberBirthdate: Date;
  BenefitsChangedOn: Date;
  BenefitsNonDuplication: boolean;
  BenefitsMaximum: number;
  BenefitsLeft: number;
  // TODO: Spelling - 2 words
  BenefitsDeductableLeftPreventitive: number;
  // TODO: Spelling
  BenefitsDeductableLeftStandard: number;
  // TODO: Spelling
  BenefitsDeductableLeftOther: number;
  dataInsurance: InsuranceDataModel;
  SubscriberContact: ContactDataModel;
  dataContact: ContactDataModel;
  enumInsuranceRelation: EnumValidValueItemModel;
  CoveragePreventitive: number;
  CoverageStandard: number;
  CoverageOther: number;
  isActive: boolean = true;
  BenefitsDeductibleLeft : number;
  isBenefitsPreventative: boolean;
  isBenefitsStandard: boolean;
  isBenefitsOther: boolean;
}
